import { render, staticRenderFns } from "./NotificationsDropDown.vue?vue&type=template&id=23d6c16a&"
import script from "./NotificationsDropDown.vue?vue&type=script&lang=js&"
export * from "./NotificationsDropDown.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsDropDown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports